module.exports = __webpack_public_path__ + "img/icon-empty-holder.a3e9b572.svg";